import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { MatDateFormats } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  
  // This is the key method that fixes the IST issue
  private getDateInIST(date: Date): Date {
    if (!date) return new Date();
    
    // IST offset (UTC+5:30)
    const istOffsetMilliseconds = 5.5 * 60 * 60 * 1000;
    const utcTime = date.getTime() + (date.getTimezoneOffset() * 60 * 1000);
    const istTime = new Date(utcTime + istOffsetMilliseconds);
    
    return new Date(istTime.getFullYear(), istTime.getMonth(), istTime.getDate());
  }

  // Override the key methods that Material DatePicker uses
  getDate(date: Date): number {
    return this.getDateInIST(date).getDate();
  }

  getMonth(date: Date): number {
    return this.getDateInIST(date).getMonth();
  }

  getYear(date: Date): number {
    return this.getDateInIST(date).getFullYear();
  }

  // Override parse to handle date input correctly
  parse(value: any): Date | null {
    if (!value) return null;
    
    if (value instanceof Date) {
      return this.getDateInIST(value);
    }

    // Handle string dates (DD/MM/YYYY)
    if (typeof value === 'string') {
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);
        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
          return new Date(Date.UTC(year, month, day));
        }
      }
    }

    return null;
  }

  // Override today() to return today's date in IST
  today(): Date {
    return this.getDateInIST(new Date());
  }
}

// Date format configuration - optional but recommended
export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};